/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Config object
 */
export interface Config { 
    /**
     * Primary Key
     */
    id?: number;
    /**
     * Description of the config
     */
    description?: string;
    /**
     * Schema name
     */
    schemaName?: string;
    /**
     * Table name
     */
    tableName?: string;
    /**
     * Columns of the config
     */
    columns?: string;
}

